export default {
  simulators: [
    {
      key: 'shm-simulator',
      href: 'https://nmn.gl/SHM-simulator',
      name: 'Simple Harmonic Motion',
      type: 'Simulator',
      createdAt: '2015-02',
      color: '#9C27B0',
      description: `<p>My earliest simulation, the one where it all began. I just knew that simple harmonic motion would be fun to look at animated, so I made a simulation where I could easily tinker with the variables and see the formulas.</p>`
    },
    {
      key: 'acgen',
      href: 'https://nmn.gl/acgen',
      name: 'AC Generator',
      type: 'Simulator',
      createdAt: '2015-10',
      color: '#3F51B5',
      description: `<p>Current electricity was one of my favourite topics in High School Physics. I they look beautiful while operating so I made this simulation.</p>`
    },
    {
      key: 'diode',
      href: 'https://nmn.gl/diode/',
      name: 'P-N Junction Diode',
      type: 'Simulator',
      createdAt: '2015-12',
      color: '#ff5589',
      description: `<p>When I first studied them, the workings of a diode and their "depletion region" confused me. Given how essential they are for computing, I wanted to understand them better. Making this simulation helped.</p>`
    },
    {
      key: 'collisions',
      href: 'https://nmn.gl/collisions',
      name: 'Collisions',
      type: 'Simulator',
      createdAt: '2015-08',
      color: '#0ead15',
      description: `<p>This one is a simulation of two dimensional elastic collisions, where I chose to demonstrate how the particles in a low density gas might collide.</p>`
    },
    {
      key: 'equipot',
      href: 'https://nmn.gl/Equipot',
      name: 'Equipotential Surfaces',
      type: 'Simulator',
      createdAt: '2015-08',
      color: '#FF5722',
      description: `<p>Equipotential surfaces for equal charges were seen in my textbook, but I didn't notice one with a positive and equally opposite negative charge. So, I decided to make one.</p>`
    }
  ]
} 


// WEBPACK FOOTER //
// ./src/components/Physics/data.js